import { render } from "./AboutUs.vue?vue&type=template&id=28c77cce"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/AboutUs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28c77cce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28c77cce', __exports__)) {
    api.reload('28c77cce', __exports__)
  }
  
  module.hot.accept("./AboutUs.vue?vue&type=template&id=28c77cce", () => {
    api.rerender('28c77cce', render)
  })

}


export default __exports__